import React, { useState } from "react";
import ImageIcon from "../../assets/images/img-1.jpg";
import Video1 from "../../assets/images/Tutorial Video/video-in-English.mp4";
import Video2 from "../../assets/images/Tutorial Video/video-in-hindi.mp4";
import secureLocalStorage from "react-secure-storage";
import Swal from "sweetalert2";
import configure from "configure";
import axios from "axios";

const VideoSection = ({ onClose }) => {
  const userLocation = secureLocalStorage.getItem("User");
  const [language, setLanguage] = useState(
    userLocation?.location == 1 ? null : "1"
  );

  const onSkip = () => {
    secureLocalStorage.setItem("tutorial", "skip");
    const video = document.getElementById("tutorial-video");
    if (video && !video.paused) {
      video.pause();
    }
    onClose(true);
  };
  const onSkipFuture = () => {
    const userData = secureLocalStorage.getItem("User");
    const token = secureLocalStorage.getItem("Token");
    Swal.fire({
      title: "Are you sure?",
      text: "You don't want to see the Introducer Portal Walkthrough automatically next time.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, I'm Sure!",
      cancelButtonText: "Cancel",
    }).then(async (isOkay) => {
      if (isOkay?.isConfirmed) {
        const res = await axios.get(
          `${configure.apiUrl}/help/${userData?.id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (res?.data?.success) {
          secureLocalStorage.setItem("tutorial", "skip");
          const video = document.getElementById("tutorial-video");
          if (video && !video.paused) {
            video.pause();
          }
          onClose(true);
        }
      }
    });
  };

  return (
    <div className="mt-4">
      <div className="d-flex gap-2 justify-content-centers">
        <div
          className={`tabs  added-tabs ${language == 1 ? "active" : ""}`}
          onClick={() => setLanguage(1)}
        >
          <a className="d-flex align-items-center justify-content-center">
            English
          </a>
        </div>
        {userLocation?.location == 1 ? (
          <div
            className={`tabs  added-tabs ${language == 2 ? "active" : ""}`}
            onClick={() => setLanguage(2)}
          >
            <a className="d-flex align-items-center justify-content-center">
              Hindi
            </a>
          </div>
        ) : null}
      </div>
      <div className="mt-3">
        {language != null ? (
          <div>
            <video
              controls
              id="tutorial-video"
              style={{ width: "100%" }}
              key={language}
              onContextMenu={(e) => e.preventDefault()}
            >
              <source src={language == 1 ? Video1 : Video2} type="video/mp4" />
            </video>

            <div className=" d-flex justify-content-between gap-2 mt-2">
              <button
                className="btn-meetings btn px-2 py-2"
                style={{
                  background: "rgba(0, 0, 0, 0.09)",
                  color: "#000000b2",
                  fontSize: "12px",
                }}
                onClick={() => onSkipFuture()}
              >
                Never Show Again
              </button>
              <button
                className="btn-meeting btn px-2 py-2"
                onClick={() => onSkip()}
                style={{
                  fontSize: "12px",
                }}
              >
                <i className="bx bx-skip-next"></i> Skip Walkthrough
              </button>
            </div>
          </div>
        ) : (
          <div className="d-flex flex-column align-items-center justify-content-center">
            <img src={ImageIcon} alt="No Img" width="300" />
            <h5 className="text-purple fw-bold  lh-lg text-center">
              🌐 Select your language to start the <br /> Introducer Portal
              Walkthrough: A Complete User Guide! 🧭✨
            </h5>
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoSection;
